
// General
export const CLEAR_STATE = 'CLEAR_STATE'
export const CLEAR_CACHE = 'CLEAR_CACHE'

// Auth
export const SET_INSTANCE = 'SET_INSTANCE'
export const AUTHENTICATE = 'AUTHENTICATE'
export const AUTHENTICATE_FAILURE = 'AUTHENTICATE_FAILURE'
export const REAUTHENTICATION_REQUIRED = 'REAUTHENTICATION_REQUIRED'
export const REAUTHENTICATE = 'REAUTHENTICATE'
export const REAUTHENTICATING = 'REAUTHENTICATING'
export const REAUTHENTICATE_FAILURE = 'REAUTHENTICATE_FAILURE'
export const LOGOUT = 'LOGOUT'
export const VERIFY_AUTH = 'VERIFY_AUTH'
export const RECEIVE_INSTANCES = 'RECEIVE_INSTANCES'
export const REMOVE_INSTANCE = 'REMOVE_INSTANCE'
export const SWITCH_ACTIVE_APP_INSTANCE = 'SWITCH_ACTIVE_APP_INSTANCE'
export const SWITCHING_ACTIVE_APP_INSTANCE = 'SWITCHING_ACTIVE_APP_INSTANCE'
export const CLEAR_AUTH_STATE = 'CLEAR_AUTH_STATE'
export const CLEAR_LOCALSTORAGE_INSTANCES = 'CLEAR_LOCALSTORAGE_INSTANCES'
export const SET_POST_AUTHORIZATION_ROUTE = 'SET_POST_AUTHORIZATION_ROUTE'
export const SET_LOGOUT_NOTIF_MSG = 'SET_LOGOUT_NOTIF_MSG'
export const SABOTAGE_TOKEN = 'SABOTAGE_TOKEN'
export const SET_AUTH_VERIFICATION_TIMER = 'SET_AUTH_VERIFICATION_TIMER'
export const RENEW_TOKEN = 'RENEW_TOKEN'
export const RENEW_TOKEN_FAILURE = 'RENEW_TOKEN_FAILURE'

// Ledger
export const RECEIVE_LEDGERITEMS = 'RECEIVE_LEDGERITEMS'
export const RECEIVE_LEDGERITEM_FAILURE = 'RECEIVE_LEDGERITEM_FAILURE'
export const RECEIVING_LEDGERITEMS = 'RECEIVING_LEDGERITEMS'
export const RECEIVE_LEDGER_METADATA = 'RECEIVE_LEDGER_METADATA'
export const RESET_LEDGER_META = 'RESET_LEDGER_META'
export const CLEAR_LEDGER_STATE = 'CLEAR_LEDGER_STATE'

// Batches
export const RECEIVE_BATCHES = 'RECEIVE_BATCHES'
export const RECEIVING_BATCHES = 'RECEIVING_BATCHES'
export const RECEIVE_BATCH_METADATA = 'RECEIVE_BATCH_METADATA'
export const SAVING_BATCH = 'SAVING_BATCH'
export const UPDATING_BATCH = 'UPDATING_BATCH'
export const DELETE_BATCH = 'DELETE_BATCH'
export const DELETING_BATCH = 'DELETING_BATCH'
export const RESET_BATCH_META = 'RESET_BATCH_META'
export const CLEAR_BATCH_STATE = 'CLEAR_BATCH_STATE'
export const INCREMENT_BATCH_COUNT = 'INCREMENT_BATCH_COUNT'

// Journal entries
export const RECEIVE_JES = 'RECEIVE_JES'
export const RECEIVING_JES = 'RECEIVING_JES'
export const RECEIVE_JE_METADATA = 'RECEIVE_JE_METADATA'
export const RECEIVE_JE_FAILURE = 'RECEIVE_JE_FAILURE'
export const RECEIVE_JE_LINES = 'RECEIVE_JE_LINES'
export const RECEIVE_ALL_JE_LINES = 'RECEIVE_ALL_JE_LINES'
export const RECEIVING_JE_LINES = 'RECEIVING_JE_LINES'
export const RECEIVE_JE_LINES_METADATA = 'RECEIVING_JE_LINES_METADATA'
export const RECEIVE_JE_LINES_FAILURE = 'RECEIVE_JE_LINES_FAILURE'
export const SAVING_JE_LINES = 'SAVING_JE_LINES'
export const SAVING_JE_LINES_FAILURE = 'SAVING_JE_LINES'
export const UPDATING_JE_LINES = 'UPDATING_JE_LINES'
export const UPDATING_JE_LINES_FAILURE = 'UPDATING_JE_LINES_FAILURE'
export const DELETE_JE_LINES = 'DELETE_JE_LINES'
export const CLEAR_JE_STATE = 'CLEAR_JE_STATE'
export const CLEAR_JE_UPDATE_ERR_STATE = 'CLEAR_JE_UPDATE_ERR_STATE'
export const RESET_JE_META = 'RESET_JE_META'
export const UPDATE_CURRENT_JE_PAGE = 'UPDATE_CURRENT_JE_PAGE'
export const INCREMENT_JE_COUNT = 'INCREMENT_JE_COUNT'
export const RECEIVE_ALL_JES = 'RECEIVE_ALL_JES'
export const CLEAR_JE_TRX_LINES = 'CLEAR_JE_TRX_LINES'

// Accounts payable
export const RECEIVE_APS = 'RECEIVE_APS'
export const RECEIVING_APS = 'RECEIVING_APS'
export const RECEIVE_AP_METADATA = 'RECEIVE_AP_METADATA'
export const RECEIVE_AP_FAILURE = 'RECEIVE_AP_FAILURE'
export const RECEIVE_AP_LINES = 'RECEIVE_AP_LINES'
export const RECEIVE_ALL_AP_LINES = 'RECEIVE_ALL_AP_LINES'
export const RECEIVING_AP_LINES = 'RECEIVING_AP_LINES'
export const RECEIVE_AP_LINES_METADATA = 'RECEIVING_AP_LINES_METADATA'
export const RECEIVE_AP_LINES_FAILURE = 'RECEIVE_AP_LINES_FAILURE'
export const SAVING_AP_LINES = 'SAVING_AP_LINES'
export const SAVING_AP_LINES_FAILURE = 'SAVING_AP_LINES'
export const UPDATING_AP_LINES = 'UPDATING_AP_LINES'
export const UPDATING_AP_LINES_FAILURE = 'UPDATING_AP_LINES_FAILURE'
export const DELETE_AP_LINES = 'DELETE_AP_LINES'
export const CLEAR_AP_STATE = 'CLEAR_AP_STATE'
export const CLEAR_AP_UPDATE_ERR_STATE = 'CLEAR_AP_UPDATE_ERR_STATE'
export const UPDATE_CURRENT_AP_PAGE = 'UPDATE_CURRENT_AP_PAGE'
export const INCREMENT_AP_COUNT = 'INCREMENT_AP_COUNT'
export const RESET_AP_META = 'RESET_AP_META'
export const RECEIVE_ALL_APS = 'RECEIVE_ALL_APS'
export const CLEAR_AP_TRX_LINES = 'CLEAR_AP_TRX_LINES'

// Accounts Receivable
export const RECEIVE_AR = 'RECEIVE_AR'
export const RECEIVING_AR = 'RECEIVING_AR'
export const RECEIVE_ALL_AR = 'RECEIVE_ALL_AR'
export const RECEIVE_AR_METADATA = 'RECEIVE_AR_METADATA'
export const INCREMENT_AR_COUNT = 'INCREMENT_AR_COUNT'
export const RECEIVE_AR_LINES = 'RECEIVE_AR_LINES'
export const RECEIVE_ALL_AR_LINES = 'RECEIVE_ALL_AR_LINES'
export const RECEIVING_AR_LINES = 'RECEIVING_AR_LINES'
export const RECEIVE_AR_LINES_METADATA = 'RECEIVE_AR_LINES_METADATA'
export const RECEIVE_AR_LINES_FAILURE = 'RECEIVE_AR_LINES_FAILURE'
export const SAVING_AR_LINES = 'SAVING_AR_LINES'
export const UPDATING_AR_LINES = 'UPDATING_AR_LINES'
export const CLEAR_AR_STATE = 'CLEAR_AR_STATE'
export const RESET_AR_META = 'RESET_AR_META'
export const UPDATE_CURRENT_AR_PAGE = 'UPDATE_CURRENT_AR_PAGE'
export const DELETE_AR_LINES = 'DELETE_AR_LINES'
export const CLEAR_AR_TRX_LINES = 'CLEAR_AR_TRX_LINES'

// Bill Payments
export const RECEIVE_BP = 'RECEIVE_BP'
export const RECEIVING_BP = 'RECEIVING_BP'
export const RECEIVE_ALL_BP = 'RECEIVE_ALL_BP'
export const RECEIVE_BP_METADATA = 'RECEIVE_BP_METADATA'
export const INCREMENT_BP_COUNT = 'INCREMENT_BP_COUNT'
export const RECEIVE_BP_LINES = 'RECEIVE_BP_LINES'
export const RECEIVE_ALL_BP_LINES = 'RECEIVE_ALL_BP_LINES'
export const RECEIVING_BP_LINES = 'RECEIVING_BP_LINES'
export const RECEIVE_BP_LINES_METADATA = 'RECEIVE_BP_LINES_METADATA'
export const RECEIVE_BP_LINES_FAILURE = 'RECEIVE_BP_LINES_FAILURE'
export const SAVING_BP_LINES = 'SAVING_BP_LINES'
export const UPDATING_BP_LINES = 'UPDATING_BP_LINES'
export const CLEAR_BP_STATE = 'CLEAR_BP_STATE'
export const RESET_BP_META = 'RESET_BP_META'
export const UPDATE_CURRENT_BP_PAGE = 'UPDATE_CURRENT_BP_PAGE'
export const DELETE_BP_LINES = 'DELETE_BP_LINES'
export const CLEAR_BP_TRX_LINES = 'CLEAR_BP_TRX_LINE'

// Deposits/Prepayments
export const RECEIVE_PP = 'RECEIVE_PP'
export const RECEIVING_PP = 'RECEIVING_PP'
export const RECEIVE_ALL_PP = 'RECEIVE_ALL_PP'
export const RECEIVE_PP_METADATA = 'RECEIVE_PP_METADATA'
export const INCREMENT_PP_COUNT = 'INCREMENT_PP_COUNT'
export const RECEIVE_PP_LINES = 'RECEIVE_PP_LINES'
export const RECEIVE_ALL_PP_LINES = 'RECEIVE_ALL_PP_LINES'
export const RECEIVING_PP_LINES = 'RECEIVING_PP_LINES'
export const RECEIVE_PP_LINES_METADATA = 'RECEIVE_PP_LINES_METADATA'
export const RECEIVE_PP_LINES_FAILURE = 'RECEIVE_PP_LINES_FAILURE'
export const SAVING_PP_LINES = 'SAVING_PP_LINES'
export const UPDATING_PP_LINES = 'UPDATING_PP_LINES'
export const CLEAR_PP_STATE = 'CLEAR_PP_STATE'
export const RESET_PP_META = 'RESET_PP_META'
export const UPDATE_CURRENT_PP_PAGE = 'UPDATE_CURRENT_PP_PAGE'
export const DELETE_PP_LINES = 'DELETE_PP_LINES'
export const CLEAR_PP_TRX_LINES = 'CLEAR_PP_TRX_LINES'

// Purchase orders
export const RECEIVE_POS = 'RECEIVE_POS'
export const RECEIVING_POS = 'RECEIVING_POS'
export const RECEIVE_PO_METADATA = 'RECEIVE_PO_METADATA'
export const RECEIVE_PO_FAILURE = 'RECEIVE_PO_FAILURE'
export const RECEIVE_PO_LINES = 'RECEIVE_PO_LINES'
export const RECEIVE_ALL_PO_LINES = 'RECEIVE_ALL_PO_LINES'
export const RECEIVING_PO_LINES = 'RECEIVING_PO_LINES'
export const RECEIVE_PO_LINES_METADATA = 'RECEIVING_PO_LINES_METADATA'
export const RECEIVE_PO_LINES_FAILURE = 'RECEIVE_PO_LINES_FAILURE'
export const SAVING_PO_LINES = 'SAVING_PO_LINES'
export const SAVING_PO_LINES_FAILURE = 'SAVING_PO_LINES'
export const UPDATING_PO_LINES = 'UPDATING_PO_LINES'
export const UPDATING_PO_LINES_FAILURE = 'UPDATING_PO_LINES_FAILURE'
export const DELETE_PO_LINES = 'DELETE_PO_LINES'
export const ADD_LINE_REF_TO_PO = 'ADD_LINE_REF_TO_PO'
export const CLEAR_PO_STATE = 'CLEAR_PO_STATE'
export const CLEAR_PO_UPDATE_ERR_STATE = 'CLEAR_PO_UPDATE_ERR_STATE'
export const RESET_PO_META = 'RESET_PO_META'
export const UPDATE_CURRENT_PO_PAGE = 'UPDATE_CURRENT_PO_PAGE'
export const INCREMENT_PO_COUNT = 'INCREMENT_PO_COUNT'
export const RECEIVE_ALL_POS = 'RECEIVE_ALL_POS'
export const CLEAR_ALL_PO_LINES_STATE = 'CLEAR_ALL_PO_LINES_STATE'
export const CLEAR_PO_TRX_LINES = 'CLEAR_PO_TRX_LINES'

// Petty Cash
export const RECEIVE_PCS = 'RECEIVE_PCS'
export const RECEIVING_PCS = 'RECEIVING_PCS'
export const RECEIVE_PC_METADATA = 'RECEIVE_PC_METADATA'
export const RECEIVE_PC_FAILURE = 'RECEIVE_PC_FAILURE'
export const RECEIVE_PC_LINES = 'RECEIVE_PC_LINES'
export const RECEIVE_ALL_PC_LINES = 'RECEIVE_ALL_PC_LINES'
export const RECEIVING_PC_LINES = 'RECEIVING_PC_LINES'
export const RECEIVE_PC_LINES_METADATA = 'RECEIVING_PC_LINES_METADATA'
export const RECEIVE_PC_LINES_FAILURE = 'RECEIVE_PC_LINES_FAILURE'
export const SAVING_PC_LINES = 'SAVING_PC_LINES'
export const SAVING_PC_LINES_FAILURE = 'SAVING_PC_LINES'
export const UPDATING_PC_LINES = 'UPDATING_PC_LINES'
export const UPDATING_PC_LINES_FAILURE = 'UPDATING_PC_LINES_FAILURE'
export const DELETE_PC_LINES = 'DELETE_PC_LINES'
export const CLEAR_PC_STATE = 'CLEAR_PC_STATE'
export const CLEAR_PC_UPDATE_ERR_STATE = 'CLEAR_PC_UPDATE_ERR_STATE'
export const RESET_PC_META = 'RESET_PC_META'
export const UPDATE_CURRENT_PC_PAGE = 'UPDATE_CURRENT_PC_PAGE'
export const INCREMENT_PC_COUNT = 'INCREMENT_PC_COUNT'
export const RECEIVE_ALL_PCS = 'RECEIVE_ALL_PCS'
export const CLEAR_PC_TRX_LINES = 'CLEAR_PC_TRX_LINES'

// Banks
export const RECEIVE_BANKS = 'RECEIVE_BANKS'
export const RECEIVING_BANKS = 'RECEIVING_BANKS'
export const RECEIVE_BANK_METADATA = 'RECEIVE_BANK_METADATA'
export const RECEIVE_BANKS_FAILURE = 'RECEIVE_BANK_FAILURE'
export const SAVING_BANK = 'SAVING_BANK'
export const SAVING_BANK_FAILURE = 'SAVING_BANK_FAILURE'
export const UPDATING_BANK = 'UPDATING_BANK'
export const UPDATING_BANK_FAILURE = 'UPDATING_BANK_FAILURE'
export const DELETE_BANK = 'DELETE_BANK'
export const DELETING_BANK = 'DELETING_BANK'
export const DELETING_BANK_FAILURE = 'DELETING_BANK_FAILURE'
export const RECEIVE_CHECK_NUMBERS = 'RECEIVE_CHECK_NUMBERS'
export const RECEIVING_CHECK_NUMBERS = 'RECEIVING_CHECK_NUMBERS'
export const RECEIVE_CHECK_NUMBERS_FAILURE = 'RECEIVE_CHECK_NUMBERS_FAILURE'
export const RECEIVE_BANK_STATEMENTS = 'RECEIVE_BANK_STATEMENTS'
export const RECEIVING_BANK_STATEMENTS = 'RECEIVING_BANK_STATEMENTS'
export const RECEIVE_BANK_STATEMENTS_FAILURE = 'RECEIVE_BANK_STATEMENTS_FAILURE'
export const CLEAR_CHECK_NUMBERS = 'CLEAR_CHECK_NUMBERS'
export const CLEAR_BANK_STATE = 'CLEAR_BANK_STATE'
export const RESET_BANK_META = 'RESET_BANK_META'
export const INCREMENT_BANK_COUNT = 'INCREMENT_BANK_COUNT'

// Periods
export const RECEIVE_PERIODS = 'RECEIVE_PERIODS'
export const RECEIVING_PERIODS = 'RECEIVING_PERIODS'
export const RECEIVE_PERIOD_METADATA = 'RECEIVE_PERIOD_METADATA'
export const RECEIVE_PERIOD_FAILURE = 'RECEIVE_PERIOD_FAILURE'
export const SAVING_PERIOD = 'SAVING_PERIOD'
export const SAVING_PERIOD_FAILURE = 'SAVING_PERIOD_FAILURE'
export const UPDATING_PERIOD_FAILURE = 'UPDATING_PERIOD_FAILURE'
export const UPDATING_PERIOD = 'UPDATING_PERIOD'
export const DELETE_PERIOD = 'DELETE_PERIOD'
export const DELETING_PERIOD = 'DELETING_PERIOD'
export const DELETING_PERIOD_FAILURE = 'DELETING_PERIOD_FAILURE'
export const RESET_PERIOD_META = 'RESET_PERIOD_META'
export const CLEAR_PERIOD_STATE = 'CLEAR_PERIOD_STATE'
export const INCREMENT_PERIOD_COUNT = 'INCREMENT_PERIOD_COUNT'
export const RECEIVE_PERIODS_QUOTE = 'RECEIVE_PERIODS_QUOTE'
export const RECEIVING_PERIODS_QUOTE = 'RECEIVING_PERIODS_QUOTE'
export const RECEIVE_PERIODS_QUOTE_FAILURE = 'RECEIVE_PERIODS_QUOTE_FAILURE'

// Accounts
export const RECEIVE_ACCOUNTS = 'RECEIVE_ACCOUNTS'
export const RECEIVE_ACCOUNT = 'RECEIVE_ACCOUNT'
export const RECEIVE_ACCOUNT_METADATA = 'RECEIVE_ACCOUNT_METADATA'
export const RECEIVE_ACCOUNT_FAILURE = 'RECEIVE_ACCOUNT_FAILURE'
export const RECEIVE_EMPLOYEE_FAILURE = 'RECEIVE_EMPLOYEE_FAILURE'
export const RECEIVE_ALL_EMPLOYEE = 'RECEIVE_ALL_EMPLOYEE'
export const RECEIVE_ALL_INVOICES = 'RECEIVE_ALL_INVOICES'
export const RECEIVE_INVOICES_FAILURE = 'RECEIVE_INVOICES_FAILURE'
export const RECEIVING_ACCOUNTS = 'RECEIVING_ACCOUNTS'
export const SAVING_ACCOUNT = 'SAVING_ACCOUNT'
export const SAVING_ACCOUNT_FAILURE = 'SAVING_ACCOUNT_FAILURE'
export const UPDATING_ACCOUNT_FAILURE = 'UPDATING_ACCOUNT_FAILURE'
export const UPDATING_ACCOUNT = 'UPDATING_ACCOUNT'
export const DELETE_ACCOUNT = 'DELETE_ACCOUNT'
export const DELETING_ACCOUNT = 'DELETING_ACCOUNT'
export const DELETING_ACCOUNT_FAILURE = 'DELETING_ACCOUNT_FAILURE'
export const RESET_ACCOUNT_META = 'RESET_ACCOUNT_META'
export const CLEAR_ACCOUNT_STATE = 'CLEAR_ACCOUNT_STATE'
export const INCREMENT_ACCOUNT_COUNT = 'INCREMENT_ACCOUNT_COUNT'
export const APPLY_LOCAL_ACCOUNT_SEARCH = 'APPLY_LOCAL_ACCOUNT_SEARCH'
export const CLEAR_LOCAL_ACCOUNT_SEARCH = 'CLEAR_LOCAL_ACCOUNT_SEARCH'

// Vendors
export const RECEIVE_VENDORS = 'RECEIVE_VENDORS'
export const RECEIVE_VENDOR = 'RECEIVE_VENDOR'
export const RECEIVE_ALL_VENDORS = 'RECEIVE_ALL_VENDORS'
export const RECEIVE_PARENT_VENDORS = 'RECEIVE_PARENT_VENDORS'
export const RECEIVING_VENDORS = 'RECEIVING_VENDORS'
export const RECEIVE_VENDOR_METADATA = 'RECEIVE_VENDOR_METADATA'
export const RECEIVE_VENDOR_FAILURE = 'RECEIVE_VENDOR_FAILURE'
export const SAVING_VENDOR = 'SAVING_VENDOR'
export const UPDATING_VENDOR = 'UPDATING_VENDOR'
export const UPDATING_VENDOR_FAILURE = 'UPDATING_VENDOR_FAILURE'
export const DELETE_VENDOR = 'DELETE_VENDOR'
export const DELETING_VENDOR = 'DELETING_VENDOR'
export const DELETING_VENDOR_FAILURE = 'DELETING_VENDOR_FAILURE'
export const CLEAR_VENDOR_STATE = 'CLEAR_VENDOR_STATE'
export const RESET_VENDOR_META = 'RESET_VENDOR_META'
export const UPDATE_CURRENT_VENDOR_PAGE = 'UPDATE_CURRENT_VENDOR_PAGE'
export const INCREMENT_VENDOR_COUNT = 'INCREMENT_VENDOR_COUNT'

// Productions
export const RECEIVE_PRODUCTIONS = 'RECEIVE_PRODUCTIONS'
export const RECEIVING_PRODUCTIONS = 'RECEIVING_PRODUCTIONS'
export const RECEIVE_PRODUCTION_METADATA = 'RECEIVE_PRODUCTION_METADATA'
export const RECEIVE_PRODUCTION_FAILURE = 'RECEIVE_PRODUCTION_FAILURE'
export const SAVING_PRODUCTION = 'SAVING_PRODUCTION'
export const SAVING_PRODUCTION_FAILURE = 'SAVING_PRODUCTION_FAILURE'
export const UPDATING_PRODUCTION = 'UPDATING_PRODUCTION'
export const UPDATING_PRODUCTION_FAILURE = 'UPDATING_PRODUCTION_FAILURE'
export const DELETE_PRODUCTION = 'DELETE_PRODUCTION'
export const DELETING_PRODUCTION = 'DELETING_PRODUCTION'
export const DELETING_PRODUCTION_FAILURE = 'DELETING_PRODUCTION_FAILURE'
export const RESET_PRODUCTION_META = 'RESET_PRODUCTION_META'
export const CLEAR_PRODUCTION_STATE = 'CLEAR_PRODUCTION_STATE'
export const INCREMENT_PRODUCTION_COUNT = 'INCREMENT_PRODUCTION_COUNT'
export const SET_ALL_PRODUCTIONS_LOADED = 'SET_ALL_PRODUCTIONS_LOADED'

// Companies
export const RECEIVE_COMPANIES = 'RECEIVE_COMPANIES'
export const RECEIVING_COMPANIES = 'RECEIVING_COMPANIES'
export const RECEIVE_COMPANY_METADATA = 'RECEIVE_COMPANY_METADATA'
export const SAVING_COMPANY = 'SAVING_COMPANY'
export const UPDATING_COMPANY = 'UPDATING_COMPANY'
export const DELETE_COMPANY = 'DELETE_COMPANY'
export const DELETING_COMPANY = 'DELETING_COMPANY'
export const CLEAR_COMPANY_STATE = 'CLEAR_COMPANY_STATE'
export const RESET_COMPANY_META = 'RESET_COMPANY_META'
export const INCREMENT_COMPANY_COUNT = 'INCREMENT_COMPANY_COUNT'
export const SET_ALL_COMPANIES_LOADED = 'SET_ALL_COMPANIES_LOADED'

// Source codes
export const RECEIVE_SCS = 'RECEIVE_SCS'
export const RECEIVING_SCS = 'RECEIVING_SCS'
export const RECEIVE_SC_METADATA = 'RECEIVE_SC_METADATA'
export const SAVING_SC = 'SAVING_SC'
export const UPDATING_SC = 'UPDATING_SC'
export const DELETE_SC = 'DELETE_SC'
export const DELETING_SC = 'DELETING_SC'
export const CLEAR_SC_STATE = 'CLEAR_SC_STATE'
export const RESET_SC_META = 'RESET_SC_META'
export const INCREMENT_SC_COUNT = 'INCREMENT_SC_COUNT'

// Checks
export const RECEIVE_CHECKS = 'RECEIVE_CHECKS'
export const RECEIVING_CHECKS = 'RECEIVING_CHECKS'
export const RECEIVE_CHECK_METADATA = 'RECEIVE_CHECK_METADATA'
export const RECEIVE_CHECK_FAILURE = 'RECEIVE_CHECK_FAILURE'
export const SAVING_CHECK = 'SAVING_CHECK'
export const SAVING_CHECK_FAILURE = 'SAVING_CHECK_FAILURE'
export const UPDATING_CHECK = 'UPDATING_CHECK'
export const UPDATING_CHECK_FAILURE = 'UPDATING_CHECK_FAILURE'
export const DELETE_CHECK = 'DELETE_CHECK'
export const DELETING_CHECK = 'DELETING_CHECK'
export const DELETING_CHECK_FAILURE = 'DELETING_CHECK_FAILURE'
export const UPDATE_CURRENT_CHECK_PAGE = 'UPDATE_CURRENT_CHECK_PAGE'
export const CHANGE_RECONCILABLE_CHECKS_PAGE = 'CHANGE_RECONCILABLE_CHECKS_PAGE'
export const RESET_CHECK_META = 'RESET_CHECK_META'
export const CLEAR_CHECK_STATE = 'CLEAR_CHECK_STATE'
export const INCREMENT_CHECK_COUNT = 'INCREMENT_CHECK_COUNT'
export const RECEIVE_ALL_CHECKS = 'RECEIVE_ALL_CHECKS'

// Check Runs
export const RECEIVE_CHECKRUNS = 'RECEIVE_CHECKRUNS'
export const RECEIVE_CHECKRUN_METADATA = 'RECEIVE_CHECKRUN_METADATA'
export const RECEIVE_CHECKRUN_FAILURE = 'RECEIVE_CHECKRUN_FAILURE'
export const SAVING_CHECKRUN = 'SAVING_CHECKRUN'
export const SAVING_CHECKRUN_FAILURE = 'SAVING_CHECKRUN_FAILURE'
export const UPDATING_CHECKRUN = 'UPDATING_CHECKRUN'
export const UPDATING_CHECKRUN_FAILURE = 'UPDATING_CHECKRUN_FAILURE'
export const DELETE_CHECKRUN = 'DELETE_CHECKRUN'
export const DELETING_CHECKRUN = 'DELETING_CHECKRUN'
export const DELETING_CHECKRUN_FAILURE = 'DELETING_CHECKRUN_FAILURE'
export const CLEAR_CHECKRUN_STATE = 'CLEAR_CHECKRUN_STATE'
export const RECEIVE_QUOTE = 'RECEIVE_QUOTE'
export const RECEIVE_QUOTE_FAILURE = 'RECEIVE_QUOTE_FAILURE'
export const RECEIVE_CHECK_PDF = 'RECEIVE_CHECK_PDF'
export const RECEIVING_CHECK_PDF = 'RECEIVING_CHECK_PDF'
export const RECEIVE_CHECK_PDF_FAILURE = 'RECEIVE_CHECK_PDF_FAILURE'

// Bankrecs
export const RECEIVE_BANKRECS = 'RECEIVE_BANKRECS'
export const RECEIVE_BANKREC_METADATA = 'RECEIVE_BANKREC_METADATA'
export const RECEIVE_BANKREC_FAILURE = 'RECEIVE_BANKREC_FAILURE'
export const RECEIVING_BANKREC = 'RECEIVING_BANKREC'
export const SAVE_BANKREC = 'SAVE_BANKREC'
export const SAVE_BANKREC_FAILURE = 'SAVE_BANKREC_FAILURE'
export const SAVING_BANKREC = 'SAVING_BANKREC'
export const SAVING_BANKREC_FAILURE = 'SAVING_BANKREC_FAILURE'
export const UPDATING_BANKREC = 'UPDATING_BANKREC'
export const UPDATING_BANKREC_FAILURE = 'UPDATING_BANKREC_FAILURE'
export const DELETE_BANKREC = 'DELETE_BANKREC'
export const DELETING_BANKREC = 'DELETING_BANKREC'
export const DELETING_BANKREC_FAILURE = 'DELETING_BANKREC_FAILURE'
export const RECEIVING_BANKREC_OPTIONS = 'RECEIVING_BANKREC_OPTIONS'
export const RECEIVE_BANKREC_OPTIONS_FAILURE = 'RECEIVE_BANKREC_OPTIONS_FAILURE'
export const RECEIVE_BANKREC_OPTIONS = 'RECEIVE_BANKREC_OPTIONS'
export const INCREMENT_BANKREC_COUNT = 'INCREMENT_BANKREC_COUNT'
export const RESET_BANKREC_META = 'RESET_BANKREC_META'
export const UPDATE_CURRENT_BANKREC_PAGE = 'UPDATE_CURRENT_BANKREC_PAGE'
export const CLEAR_BANKREC_STATE = 'CLEAR_BANKREC_STATE'

// Addresses
export const RECEIVE_ADDRESSES = 'RECEIVE_ADDRESSES'
export const RECEIVING_ADDRESSES = 'RECEIVING_ADDRESSES'
export const RECEIVE_ADDRESS_METADATA = 'RECEIVE_ADDRESS_METADATA'
export const RECEIVE_ADDRESS_FAILURE = 'RECEIVE_ADDRESS_FAILURE'
export const SAVING_ADDRESS = 'SAVING_ADDRESS'
export const SAVING_ADDRESS_FAILURE = 'SAVING_ADDRESS_FAILURE'
export const UPDATING_ADDRESS = 'UPDATING_ADDRESS'
export const UPDATING_ADDRESS_FAILURE = 'UPDATING_ADDRESS_FAILURE'
export const DELETE_ADDRESS = 'DELETE_ADDRESS'
export const DELETING_ADDRESS = 'DELETING_ADDRESS'
export const DELETING_ADDRESS_FAILURE = 'DELETING_ADDRESS_FAILURE'
export const RESET_ADDRESS_META = 'RESET_ADDRESS_META'
export const CLEAR_ADDRESS_STATE = 'CLEAR_ADDRESS_STATE'
export const INCREMENT_ADDRESS_COUNT = 'INCREMENT_ADDRESS_COUNT'

// Cities
export const RECEIVE_CITIES = 'RECEIVE_CITIES'
export const RECEIVING_CITIES = 'RECEIVING_CITIES'
export const RECEIVE_CITY_METADATA = 'RECEIVE_CITY_METADATA'
export const RECEIVE_CITY_FAILURE = 'RECEIVE_CITY_FAILURE'
export const SAVING_CITY = 'SAVING_CITY'
export const SAVING_CITY_FAILURE = 'SAVING_CITY_FAILURE'
export const UPDATING_CITY = 'UPDATING_CITY'
export const UPDATING_CITY_FAILURE = 'UPDATING_CITY_FAILURE'
export const DELETE_CITY = 'DELETE_CITY'
export const DELETING_CITY = 'DELETING_CITY'
export const DELETING_CITY_FAILURE = 'DELETING_CITY_FAILURE'
export const RESET_CITY_META = 'RESET_CITY_META'
export const CLEAR_CITY_STATE = 'CLEAR_CITY_STATE'
export const INCREMENT_CITY_COUNT = 'INCREMENT_CITY_COUNT'

// States
export const RECEIVE_STATES = 'RECEIVE_STATES'
export const RECEIVING_STATES = 'RECEIVING_STATES'
export const RECEIVE_STATE_METADATA = 'RECEIVE_STATE_METADATA'
export const RECEIVE_STATE_FAILURE = 'RECEIVE_STATE_FAILURE'
export const SAVING_STATE = 'SAVING_STATE'
export const SAVING_STATE_FAILURE = 'SAVING_STATE_FAILURE'
export const UPDATING_STATE = 'UPDATING_STATE'
export const UPDATING_STATE_FAILURE = 'UPDATING_STATE_FAILURE'
export const DELETE_STATE = 'DELETE_STATE'
export const DELETING_STATE = 'DELETING_STATE'
export const DELETING_STATE_FAILURE = 'DELETING_STATE_FAILURE'
export const RESET_STATE_META = 'RESET_STATE_META'
export const CLEAR_STATE_STATE = 'CLEAR_STATE_STATE'
export const INCREMENT_STATE_COUNT = 'INCREMENT_STATE_COUNT'

// Sets
export const RECEIVE_SETS = 'RECEIVE_SETS'
export const RECEIVING_SETS = 'RECEIVING_SETS'
export const RECEIVE_SET_METADATA = 'RECEIVE_SET_METADATA'
export const RECEIVE_SET_FAILURE = 'RECEIVE_SET_FAILURE'
export const SAVING_SET = 'SAVING_SET'
export const SAVING_SET_FAILURE = 'SAVING_SET_FAILURE'
export const UPDATING_SET = 'UPDATING_SET'
export const UPDATING_SET_FAILURE = 'UPDATING_SET_FAILURE'
export const DELETE_SET = 'DELETE_SET'
export const DELETING_SET = 'DELETING_SET'
export const DELETING_SET_FAILURE = 'DELETING_SET_FAILURE'
export const RESET_SET_META = 'RESET_SET_META'
export const CLEAR_SET_STATE = 'CLEAR_SET_STATE'
export const INCREMENT_SET_COUNT = 'INCREMENT_SET_COUNT'

// Series
export const RECEIVE_SERIES = 'RECEIVE_SERIES'
export const RECEIVING_SERIES = 'RECEIVING_SERIES'
export const RECEIVE_SERIES_METADATA = 'RECEIVE_SERIES_METADATA'
export const RECEIVE_SERIES_FAILURE = 'RECEIVE_SERIES_FAILURE'
export const SAVING_SERIES = 'SAVING_SERIES'
export const SAVING_SERIES_FAILURE = 'SAVING_SERIES_FAILURE'
export const UPDATING_SERIES = 'UPDATING_SERIES'
export const UPDATING_SERIES_FAILURE = 'UPDATING_SERIES_FAILURE'
export const DELETE_SERIES = 'DELETE_SERIES'
export const DELETING_SERIES = 'DELETING_SERIES'
export const DELETING_SERIES_FAILURE = 'DELETING_SERIES_FAILURE'
export const RESET_SERIES_META = 'RESET_SERIES_META'
export const CLEAR_SERIES_STATE = 'CLEAR_SERIES_STATE'
export const INCREMENT_SERIES_COUNT = 'INCREMENT_SERIES_COUNT'

// Locations
export const RECEIVE_LOCATIONS = 'RECEIVE_LOCATIONS'
export const RECEIVING_LOCATIONS = 'RECEIVING_LOCATIONS'
export const RECEIVE_LOCATION_METADATA = 'RECEIVE_LOCATION_METADATA'
export const RECEIVE_LOCATION_FAILURE = 'RECEIVE_LOCATION_FAILURE'
export const SAVING_LOCATION = 'SAVING_LOCATION'
export const SAVING_LOCATION_FAILURE = 'SAVING_LOCATION_FAILURE'
export const UPDATING_LOCATION = 'UPDATING_LOCATION'
export const UPDATING_LOCATION_FAILURE = 'UPDATING_LOCATION_FAILURE'
export const DELETE_LOCATION = 'DELETE_LOCATION'
export const DELETING_LOCATION = 'DELETING_LOCATION'
export const DELETING_LOCATION_FAILURE = 'DELETING_LOCATION_FAILURE'
export const RESET_LOCATION_META = 'RESET_LOCATION_META'
export const CLEAR_LOCATION_STATE = 'CLEAR_LOCATION_STATE'
export const INCREMENT_LOCATION_COUNT = 'INCREMENT_LOCATION_COUNT'

// Insurance Codes
export const RECEIVE_INSURANCES = 'RECEIVE_INSURANCES'
export const RECEIVING_INSURANCES = 'RECEIVING_INSURANCES'
export const RECEIVE_INSURANCE_METADATA = 'RECEIVE_INSURANCE_METADATA'
export const RECEIVE_INSURANCE_FAILURE = 'RECEIVE_INSURANCE_FAILURE'
export const SAVING_INSURANCE = 'SAVING_INSURANCE'
export const SAVING_INSURANCE_FAILURE = 'SAVING_INSURANCE_FAILURE'
export const UPDATING_INSURANCE = 'UPDATING_INSURANCE'
export const UPDATING_INSURANCE_FAILURE = 'UPDATING_INSURANCE_FAILURE'
export const DELETE_INSURANCE = 'DELETE_INSURANCE'
export const DELETING_INSURANCE = 'DELETING_INSURANCE'
export const DELETING_INSURANCE_FAILURE = 'DELETING_INSURANCE_FAILURE'
export const RESET_INSURANCE_META = 'RESET_INSURANCE_META'
export const CLEAR_INSURANCE_STATE = 'CLEAR_INSURANCE_STATE'
export const INCREMENT_INSURANCE_COUNT = 'INCREMENT_INSURANCE_COUNT'
// Account Group
export const RECEIVE_ACCOUNTGROUPS = 'RECEIVE_ACCOUNTGROUPS'
export const RECEIVING_ACCOUNTGROUPS = 'RECEIVING_ACCOUNTGROUPS'
export const RECEIVE_ACCOUNTGROUP_METADATA = 'RECEIVE_ACCOUNTGROUP_METADATA'
export const RECEIVE_ACCOUNTGROUP_FAILURE = 'RECEIVE_ACCOUNTGROUP_FAILURE'
export const SAVING_ACCOUNTGROUP = 'SAVING_ACCOUNTGROUP'
export const SAVING_ACCOUNTGROUP_FAILURE = 'SAVING_ACCOUNTGROUP_FAILURE'
export const UPDATING_ACCOUNTGROUP = 'UPDATING_ACCOUNTGROUP'
export const UPDATING_ACCOUNTGROUP_FAILURE = 'UPDATING_ACCOUNTGROUP_FAILURE'
export const DELETE_ACCOUNTGROUP = 'DELETE_ACCOUNTGROUP'
export const DELETING_ACCOUNTGROUP = 'DELETING_ACCOUNTGROUP'
export const DELETING_ACCOUNTGROUP_FAILURE = 'DELETING_ACCOUNTGROUP_FAILURE'
export const UPDATE_CURRENT_ACCOUNTGROUP_PAGE = 'UPDATE_CURRENT_ACCOUNTGROUP_PAGE'
export const CHANGE_RECONCILABLE_ACCOUNTGROUPS_PAGE = 'CHANGE_RECONCILABLE_ACCOUNTGROUPS_PAGE'
export const RESET_ACCOUNTGROUP_META = 'RESET_ACCOUNTGROUP_META'
export const CLEAR_ACCOUNTGROUP_STATE = 'CLEAR_ACCOUNTGROUP_STATE'
export const INCREMENT_ACCOUNTGROUP_COUNT = 'INCREMENT_ACCOUNTGROUP_COUNT'
export const RECEIVE_ALL_ACCOUNTGROUPS = 'RECEIVE_ALL_ACCOUNTGROUPS'
// Free fields
export const RECEIVE_FREEFIELDS = 'RECEIVE_FREEFIELDS'
export const RECEIVING_FREEFIELDS = 'RECEIVING_FREEFIELDS'
export const RECEIVE_FREEFIELD_METADATA = 'RECEIVE_FREEFIELD_METADATA'
export const RECEIVE_FREEFIELD_FAILURE = 'RECEIVE_FREEFIELD_FAILURE'
export const SAVING_FREEFIELD = 'SAVING_FREEFIELD'
export const SAVING_FREEFIELD_FAILURE = 'SAVING_FREEFIELD_FAILURE'
export const UPDATING_FREEFIELD = 'UPDATING_FREEFIELD'
export const UPDATING_FREEFIELD_FAILURE = 'UPDATING_FREEFIELD_FAILURE'
export const DELETE_FREEFIELD = 'DELETE_FREEFIELD'
export const DELETING_FREEFIELD = 'DELETING_FREEFIELD'
export const DELETING_FREEFIELD_FAILURE = 'DELETING_FREEFIELD_FAILURE'
export const RESET_FREEFIELD_META = 'RESET_FREEFIELD_META'
export const CLEAR_FREEFIELD_STATE = 'CLEAR_FREEFIELD_STATE'
export const INCREMENT_FREEFIELD_COUNT = 'INCREMENT_FREEFIELD_COUNT'

// Tax Codes
export const RECEIVE_TAXCODES = 'RECEIVE_TAXCODES'
export const RECEIVING_TAXCODES = 'RECEIVING_TAXCODES'
export const RECEIVE_TAXCODE_METADATA = 'RECEIVE_TAXCODE_METADATA'
export const RECEIVE_TAXCODE_FAILURE = 'RECEIVE_TAXCODE_FAILURE'
export const SAVING_TAXCODE = 'SAVING_TAXCODE'
export const SAVING_TAXCODE_FAILURE = 'SAVING_TAXCODE_FAILURE'
export const UPDATING_TAXCODE = 'UPDATING_TAXCODE'
export const UPDATING_TAXCODE_FAILURE = 'UPDATING_TAXCODE_FAILURE'
export const DELETE_TAXCODE = 'DELETE_TAXCODE'
export const DELETING_TAXCODE = 'DELETING_TAXCODE'
export const DELETING_TAXCODE_FAILURE = 'DELETING_TAXCODE_FAILURE'
export const RESET_TAXCODE_META = 'RESET_TAXCODE_META'
export const CLEAR_TAXCODE_STATE = 'CLEAR_TAXCODE_STATE'
export const INCREMENT_TAXCODE_COUNT = 'INCREMENT_TAXCODE_COUNT'

// Budgets
export const RECEIVE_BUDGETS = 'RECEIVE_BUDGETS'
export const RECEIVING_BUDGETS = 'RECEIVING_BUDGETS'
export const RECEIVE_BUDGET_METADATA = 'RECEIVE_BUDGET_METADATA'
export const RECEIVE_BUDGET_FAILURE = 'RECEIVE_BUDGET_FAILURE'
export const SAVING_BUDGET = 'SAVING_BUDGET'
export const SAVING_BUDGET_FAILURE = 'SAVING_BUDGET_FAILURE'
export const UPDATING_BUDGET = 'UPDATING_BUDGET'
export const UPDATING_BUDGET_FAILURE = 'UPDATING_BUDGET_FAILURE'
export const DELETE_BUDGET = 'DELETE_BUDGET'
export const DELETING_BUDGET = 'DELETING_BUDGET'
export const DELETING_BUDGET_FAILURE = 'DELETING_BUDGET_FAILURE'
export const RESET_BUDGET_META = 'RESET_BUDGET_META'
export const CLEAR_BUDGET_STATE = 'CLEAR_BUDGET_STATE'
export const INCREMENT_BUDGET_COUNT = 'INCREMENT_BUDGET_COUNT'

// Budgetlines
export const RECEIVE_BUDGETLINES = 'RECEIVE_BUDGETLINES'
export const RECEIVING_BUDGETLINE = 'RECEIVING_BUDGETLINE'
export const RECEIVE_BUDGETLINE_METADATA = 'RECEIVE_BUDGETLINE_METADATA'
export const RECEIVE_BUDGETLINE_FAILURE = 'RECEIVE_BUDGETLINE_FAILURE'
export const SAVING_BUDGETLINE = 'SAVING_BUDGETLINE'
export const SAVING_BUDGETLINE_FAILURE = 'SAVING_BUDGETLINE_FAILURE'
export const UPDATING_BUDGETLINE = 'UPDATING_BUDGETLINE'
export const UPDATING_BUDGETLINE_FAILURE = 'UPDATING_BUDGETLINE_FAILURE'
export const DELETE_BUDGETLINE = 'DELETE_BUDGETLINE'
export const DELETING_BUDGETLINE = 'DELETING_BUDGETLINE'
export const DELETING_BUDGETLINE_FAILURE = 'DELETING_BUDGETLINE_FAILURE'
export const INCREMENT_BUDGETLINE_COUNT = 'INCREMENT_BUDGETLINE_COUNT'

// Assets
export const RECEIVE_ASSETS = 'RECEIVE_ASSETS'
export const RECEIVING_ASSET = 'RECEIVING_ASSET'
export const RECEIVE_ASSET_METADATA = 'RECEIVE_ASSET_METADATA'
export const RECEIVE_ASSET_FAILURE = 'RECEIVE_ASSET_FAILURE'
export const SAVING_ASSET = 'SAVING_ASSET'
export const SAVING_ASSET_FAILURE = 'SAVING_ASSET_FAILURE'
export const UPDATING_ASSET = 'UPDATING_ASSET'
export const UPDATING_ASSET_FAILURE = 'UPDATING_ASSET_FAILURE'
export const DELETE_ASSET = 'DELETE_ASSET'
export const DELETING_ASSET = 'DELETING_ASSET'
export const DELETING_ASSET_FAILURE = 'DELETING_ASSET_FAILURE'
export const CLEAR_ASSET_STATE = 'CLEAR_ASSET_STATE'
export const RESET_ASSET_META = 'RESET_ASSET_META'
export const INCREMENT_ASSET_COUNT = 'INCREMENT_ASSET_COUNT'

// Currencies
export const RECEIVE_CURRENCIES = 'RECEIVE_CURRENCIES'
export const RECEIVING_CURRENCIES = 'RECEIVING_CURRENCIES'
export const RECEIVE_CURRENCY_METADATA = 'RECEIVE_CURRENCY_METADATA'
export const RECEIVE_CURRENCY_FAILURE = 'RECEIVE_CURRENCY_FAILURE'
export const SAVING_CURRENCY = 'SAVING_CURRENCY'
export const SAVING_CURRENCY_FAILURE = 'SAVING_CURRENCY_FAILURE'
export const UPDATING_CURRENCY = 'UPDATING_CURRENCY'
export const UPDATING_CURRENCY_FAILURE = 'UPDATING_CURRENCY_FAILURE'
export const DELETE_CURRENCY = 'DELETE_CURRENCY'
export const DELETING_CURRENCY = 'DELETING_CURRENCY'
export const DELETING_CURRENCY_FAILURE = 'DELETING_CURRENCY_FAILURE'
export const RESET_CURRENCY_META = 'RESET_CURRENCY_META'
export const CLEAR_CURRENCY_STATE = 'CLEAR_CURRENCY_STATE'
export const INCREMENT_CURRENCY_COUNT = 'INCREMENT_CURRENCY_COUNT'
export const RECEIVE_CURRENCY_FIELDS = 'RECEIVE_CURRENCY_FIELDS'

// Countries
export const RECEIVE_COUNTRIES = 'RECEIVE_COUNTRIES'
export const RECEIVING_COUNTRIES = 'RECEIVING_COUNTRIES'
export const RECEIVE_COUNTRY_METADATA = 'RECEIVE_COUNTRY_METADATA'
export const RECEIVE_COUNTRY_FAILURE = 'RECEIVE_COUNTRY_FAILURE'
export const SAVING_COUNTRY = 'SAVING_COUNTRY'
export const SAVING_COUNTRY_FAILURE = 'SAVING_COUNTRY_FAILURE'
export const UPDATING_COUNTRY = 'UPDATING_COUNTRY'
export const UPDATING_COUNTRY_FAILURE = 'UPDATING_COUNTRY_FAILURE'
export const DELETE_COUNTRY = 'DELETE_COUNTRY'
export const DELETING_COUNTRY = 'DELETING_COUNTRY'
export const DELETING_COUNTRY_FAILURE = 'DELETING_COUNTRY_FAILURE'
export const RESET_COUNTRY_META = 'RESET_COUNTRY_META'
export const CLEAR_COUNTRY_STATE = 'CLEAR_COUNTRY_STATE'
export const INCREMENT_COUNTRY_COUNT = 'INCREMENT_COUNTRY_COUNT'

// Lines
export const SAVE_LINE_ERROR = 'SAVE_LINE_ERROR'
export const LINES_HAVE_BEEN_SAVED = 'LINES_HAVE_BEEN_SAVED'
export const RECEIVE_ALL_LINES = 'RECEIVE_ALL_LINES'

// Reports
export const RECEIVE_TRANSACTIONS = 'RECEIVE_TRANSACTIONS'
export const CLEAR_TRANSACTIONS = 'CLEAR_TRANSACTIONS'
export const RECEIVING_TRANSACTIONS = 'RECEIVING_TRANSACTIONS'
export const RECEIVE_REPORT = 'RECEIVE_REPORT'
export const RECEIVING_REPORT = 'RECEIVING_REPORT'
export const RECEIVING_REPORTS = 'RECEIVING_REPORTS'
export const RECEIVE_REPORT_FAILURE = 'RECEIVE_REPORT_FAILURE'
export const RECEIVE_REPORTS_FAILURE = 'RECEIVE_REPORTS_FAILURE'
export const RECEIVE_REPORT_METADATA = 'RECEIVE_REPORT_METADATA'
export const SET_REPORT_VIEW_STATUS = 'SET_REPORT_VIEW_STATUS'
export const UPDATE_TRANSACTION_SELECTION = 'UPDATE_TRANSACTION_SELECTION'
export const UPDATE_FILTERED_TRANSACTION_SELECTION = 'UPDATE_FILTERED_TRANSACTION_SELECTION'
export const UPDATE_TRANSACTIONS_SHOWN = 'UPDATE_TRANSACTIONS_SHOWN'
export const UPDATE_CURRENT_REPORT_ID = 'UPDATE_CURRENT_REPORT_ID'
export const INCREMENT_REPORT_COUNT = 'INCREMENT_REPORT_COUNT'
export const CACHING_PARAMS = 'CACHING_PARAMS'
export const CACHE_PARAM = 'CACHE_PARAM'
export const CACHE_PARAM_FAILURE = 'CACHE_PARAM_FAILURE'
export const RECEIVE_CACHED_PARAMS = 'RECEIVE_CACHED_PARAMS'
export const RECEIVING_CACHED_PARAMS = 'RECEIVING_CACHED_PARAMS'
export const RECEIVE_CACHED_PARAMS_FAILURE = 'RECEIVE_CACHED_PARAMS_FAILURE'
export const RENDERING_REPORT = 'RENDERING_REPORT'
export const RESET_REPORT_STATE = 'RESET_REPORT_STATE'
export const SET_POST_BTN_VISIBILITY = 'SET_POST_BTN_VISIBILITY'

// Header form
export const SET_HEADER_FORM = 'SET_HEADER_FORM'
export const SET_HEADER_COMPARATOR_FORM = 'SET_HEADER_COMPARATOR_FORM'
export const CLEAR_HEADER_FORM_STATE = 'CLEAR_HEADER_FORM_STATE'
export const SET_LAST_SEARCH_RESULT = 'SET_LAST_SEARCH_RESULT'

// Cached params
export const RECEIVE_CACHED_PARAM = 'RECEIVE_CACHED_PARAM'
export const RECEIVING_CACHED_PARAM = 'RECEIVING_CACHED_PARAM'
export const RECEIVE_CACHED_PARAM_FAILURE = 'RECEIVE_CACHED_PARAM_FAILURE'
export const SAVING_CACHED_PARAM = 'SAVING_CACHED_PARAM'
export const SAVING_CACHED_PARAM_FAILURE = 'SAVING_CACHED_PARAM_FAILURE'

// Fields
export const RECEIVING_FIELDS = 'RECEIVING_FIELDS'
export const RECEIVE_REPORT_OPTIONS = 'RECEIVE_REPORT_OPTIONS'
export const RECEIVE_FORM_FIELDS = 'RECEIVE_FORM_FIELDS'
export const CLEAR_REPORT_OPTIONS = 'CLEAR_REPORT_OPTIONS'

// Filters
export const SET_FILTERS = 'SET_FILTERS'
export const UNSET_FILTERS = 'UNSET_FILTERS'
export const SET_DEFAULT_SELECTION = 'SET_DEFAULT_SELECTION'
export const UNSET_DEFAULT_SELECTION = 'UNSET_DEFAULT_SELECTION'
export const CLEAR_DEFAULT_SELECTION = 'CLEAR_DEFAULT_SELECTION'
export const CLEAR_FILTERS = 'CLEAR_FILTERS'

// UI
export const CHANGE_MODAL_VISIBILITY = 'CHANGE_MODAL_VISIBILITY'
export const NAVIGATING = 'NAVIGATING'
export const IS_EDITING_FORM = 'IS_EDITING_FORM'
export const CONFIRM_ROUTE_CHANGE = 'CONFIRM_ROUTE_CHANGE'
export const SET_DESTINATION_ROUTE = 'SET_DESTINATION_ROUTE'
export const SET_INIT_DATA_LOADING_STATUS = 'SET_INIT_DATA_LOADING_STATUS'
export const SET_INIT_DATA_LOADED_STATUS = 'SET_INIT_DATA_LOADED_STATUS'

// All Codes
export const RECEIVE_ALL_ACCOUNTS = 'RECEIVE_ALL_ACCOUNTS'
export const RECEIVE_ALL_SERIES = 'RECEIVE_ALL_SERIES'
export const RECEIVE_ALL_LOCATIONS = 'RECEIVE_ALL_LOCATIONS'
export const RECEIVE_ALL_SETS = 'RECEIVE_ALL_SETS'
export const RECEIVE_ALL_TAX_CODES = 'RECEIVE_ALL_TAX_CODES'
export const RECEIVE_ALL_FREE_FIELDS = 'RECEIVE_ALL_FREE_FIELDS'
export const RECEIVE_ALL_COMPANIES = 'RECEIVE_ALL_COMPANIES'
export const RECEIVE_ALL_PRODUCTIONS = 'RECEIVE_ALL_PRODUCTIONS'
export const RECEIVE_ALL_PERIODS = 'RECEIVE_ALL_PERIODS'
export const RECEIVE_ALL_SOURCECODES = 'RECEIVE_ALL_SOURCECODES'
export const RECEIVING_CODES = 'RECEIVING_CODES'
export const RECEIVE_ACCOUNTS_FAILURE = 'RECEIVE_ACCOUNTS_FAILURE'
export const RECEIVE_LOCATIONS_FAILURE = 'RECEIVE_LOCATIONS_FAILURE'
export const RECEIVE_SETS_FAILURE = 'RECEIVE_SETS_FAILURE'
export const RECEIVE_TAX_CODES_FAILURE = 'RECEIVE_TAX_CO_FAILUREDES'
export const RECEIVE_FREE_FIELDS_FAILURE = 'RECEIVE_FREE_FIELDS_FAILURE'
export const RECEIVE_COMPANIES_FAILURE = 'RECEIVE_COMPANIES_FAILURE'
export const RECEIVE_PRODUCTIONS_FAILURE = 'RECEIVE_PRODUCTIONS_FAILURE'
export const RECEIVE_PERIODS_FAILURE = 'RECEIVE_PERIODS_FAILURE'
export const RECEIVE_SOURCECODES_FAILURE = 'RECEIVE_SOURCECODES_FAILURE'
export const RECEIVING_CODES_FAILURE = 'RECEIVING_CODES_FAILURE'
export const RECEIVE_CODE_FAILURE = 'RECEIVE_CODE_FAILURE_FAILURE'

// Account Balances
export const RECEIVE_ACCOUNT_BALANCE = 'RECEIVE_ACCOUNT_BALANCE'
export const RECEIVE_ACCOUNT_BALANCE_LINES = 'RECEIVE_ACCOUNT_BALANCE_LINES'
export const RECEIVING_ACCOUNT_BALANCE = 'RECEIVING_ACCOUNT_BALANCE'
export const RECEIVE_ACCOUNT_BALANCE_FAILURE = 'RECEIVE_ACCOUNT_BALANCE_FAILURE'

// Salesreps
export const RECEIVE_SALESREP = 'RECEIVE_SALESREP'
export const RECEIVING_SALESREP = 'RECEIVING_SALESREP'
export const RECEIVE_SALESREP_METADATA = 'RECEIVE_SALESREP_METADATA'
export const SAVING_SALESREP = 'SAVING_SALESREP'
export const UPDATING_SALESREP = 'UPDATING_SALESREP'
export const DELETE_SALESREP = 'DELETE_SALESREP'
export const DELETING_SALESREP = 'DELETING_SALESREP'
export const RESET_SALESREP_META = 'RESET_SALESREP_META'
export const CLEAR_SALESREP_STATE = 'CLEAR_SALESREP_STATE'
export const INCREMENT_SALESREP_COUNT = 'INCREMENT_SALESREP_COUNT'
export const SET_ALL_SALESREP_LOADED = 'SET_ALL_SALESREP_LOADED'

// Customers
export const RECEIVE_CUSTOMER = 'RECEIVE_CUSTOMER'
export const RECEIVE_ALL_CUSTOMER = 'RECEIVE_ALL_CUSTOMER'
export const RECEIVE_CUSTOMER_METADATA = 'RECEIVE_CUSTOMER_METADATA'
export const RECEIVING_CUSTOMER = 'RECEIVING_CUSTOMER'
export const SAVING_CUSTOMER = 'SAVING_CUSTOMER'
export const UPDATING_CUSTOMER = 'UPDATING_CUSTOMER'
export const DELETE_CUSTOMER = 'DELETE_CUSTOMER'
export const DELETING_CUSTOMER = 'DELETING_CUSTOMER'
export const RESET_CUSTOMER_META = 'RESET_CUSTOMER_META'
export const CLEAR_CUSTOMER_STATE = 'CLEAR_CUSTOMER_STATE'
export const UPDATE_CURRENT_CUSTOMER_PAGE = 'UPDATE_CURRENT_CUSTOMER_PAGE'
export const INCREMENT_CUSTOMER_COUNT = 'INCREMENT_CUSTOMER_COUNT'

// Billable types
export const RECEIVE_BILLABLETYPE = 'RECEIVE_BILLABLETYPE'
export const RECEIVING_BILLABLETYPE = 'RECEIVING_BILLABLETYPE'
export const RECEIVE_BILLABLETYPE_METADATA = 'RECEIVE_BILLABLETYPE_METADATA'
export const SAVING_BILLABLETYPE = 'SAVING_BILLABLETYPE'
export const UPDATING_BILLABLETYPE = 'UPDATING_BILLABLETYPE'
export const DELETE_BILLABLETYPE = 'DELETE_BILLABLETYPE'
export const DELETING_BILLABLETYPE = 'DELETING_BILLABLETYPE'
export const RESET_BILLABLETYPE_META = 'RESET_BILLABLETYPE_META'
export const CLEAR_BILLABLETYPE_STATE = 'CLEAR_BILLABLETYPE_STATE'
export const INCREMENT_BILLABLETYPE_COUNT = 'INCREMENT_BILLABLETYPE_COUNT'
export const SET_ALL_BILLABLETYPE_LOADED = 'SET_ALL_BILLABLETYPE_LOADED'

// Billable items
export const RECEIVE_BILLABLEITEM = 'RECEIVE_BILLABLEITEM'
export const RECEIVING_BILLABLEITEM = 'RECEIVING_BILLABLEITEM'
export const RECEIVE_BILLABLEITEM_METADATA = 'RECEIVE_BILLABLEITEM_METADATA'
export const SAVING_BILLABLEITEM = 'SAVING_BILLABLEITEM'
export const UPDATING_BILLABLEITEM = 'UPDATING_BILLABLEITEM'
export const DELETE_BILLABLEITEM = 'DELETE_BILLABLEITEM'
export const DELETING_BILLABLEITEM = 'DELETING_BILLABLEITEM'
export const INCREMENT_BILLABLEITEM_COUNT = 'INCREMENT_BILLABLEITEM_COUNT'
export const RESET_BILLABLEITEM_META = 'RESET_BILLABLEITEM_META'
export const CLEAR_BILLABLEITEM_STATE = 'CLEAR_BILLABLEITEM_STATE'
export const SET_ALL_BILLABLEITEM_LOADED = 'SET_ALL_BILLABLEITEM_LOADED'

// Markups
export const RECEIVE_MARKUP = 'RECEIVE_MARKUP'
export const RECEIVING_MARKUP = 'RECEIVING_MARKUP'
export const RECEIVE_MARKUP_METADATA = 'RECEIVE_MARKUP_METADATA'
export const SAVING_MARKUP = 'SAVING_MARKUP'
export const UPDATING_MARKUP = 'UPDATING_MARKUP'
export const DELETE_MARKUP = 'DELETE_MARKUP'
export const DELETING_MARKUP = 'DELETING_MARKUP'
export const RESET_MARKUP_META = 'RESET_MARKUP_META'
export const CLEAR_MARKUP_STATE = 'CLEAR_MARKUP_STATE'
export const INCREMENT_MARKUP_COUNT = 'INCREMENT_MARKUP_COUNT'
export const SET_ALL_MARKUP_LOADED = 'SET_ALL_MARKUP_LOADED'

// Payment
export const RECEIVE_PAYMENTS = 'RECEIVE_PAYMENTS'
export const RECEIVING_PAYMENTS = 'RECEIVING_PAYMENTS'
export const RECEIVE_PAYMENT_METADATA = 'RECEIVE_PAYMENT_METADATA'
export const RECEIVE_PAYMENT_FAILURE = 'RECEIVE_PAYMENT_FAILURE'
export const SAVING_PAYMENT = 'SAVING_PAYMENT'
export const SAVING_PAYMENT_FAILURE = 'SAVING_PAYMENT_FAILURE'
export const UPDATING_PAYMENT = 'UPDATING_PAYMENT'
export const UPDATING_PAYMENT_FAILURE = 'UPDATING_PAYMENT_FAILURE'
export const DELETE_PAYMENT = 'DELETE_PAYMENT'
export const DELETING_PAYMENT = 'DELETING_PAYMENT'
export const DELETING_PAYMENT_FAILURE = 'DELETING_PAYMENT_FAILURE'
export const UPDATE_CURRENT_PAYMENT_PAGE = 'UPDATE_CURRENT_PAYMENT_PAGE'
export const CHANGE_RECONCILABLE_PAYMENTS_PAGE = 'CHANGE_RECONCILABLE_PAYMENTS_PAGE'
export const RESET_PAYMENT_META = 'RESET_PAYMENT_META'
export const CLEAR_PAYMENT_STATE = 'CLEAR_PAYMENT_STATE'
export const INCREMENT_PAYMENT_COUNT = 'INCREMENT_PAYMENT_COUNT'
export const RECEIVE_ALL_PAYMENTS = 'RECEIVE_ALL_PAYMENTS'

// Searched results retained after opening a transaction
export const FILTER_AP_QUERY = 'FILTER_AP_QUERY'
export const CLEAR_FILTER_AP_QUERY = 'CLEAR_FILTER_AP_QUERY'
export const FILTER_AR_QUERY = 'FILTER_AR_QUERY'
export const CLEAR_FILTER_AR_QUERY = 'CLEAR_FILTER_AR_QUERY'
export const FILTER_JE_QUERY = 'FILTER_JE_QUERY'
export const CLEAR_FILTER_JE_QUERY = 'CLEAR_FILTER_JE_QUERY'
export const FILTER_PR_QUERY = 'FILTER_PR_QUERY'
export const CLEAR_FILTER_PR_QUERY = 'CLEAR_FILTER_PR_QUERY'
export const FILTER_PO_QUERY = 'FILTER_PO_QUERY'
export const CLEAR_FILTER_PO_QUERY = 'CLEAR_FILTER_PO_QUERY'
// export const FILTER_RT_QUERY = 'FILTER_RT_QUERY'
// export const CLEAR_FILTER_RT_QUERY = 'CLEAR_FILTER_RT_QUERY'
export const FILTER_PC_QUERY = 'FILTER_PC_QUERY'
export const CLEAR_FILTER_PC_QUERY = 'CLEAR_FILTER_PC_QUERY'



// WEBPACK FOOTER //
// ./src/store/mutationTypes.js